/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MainContextSection
 */
export interface MainContextSection {
    /**
     * 
     * @type {string}
     * @memberof MainContextSection
     */
    id: string;
    /**
     * Section heading, rendered as "## {title}" when composed.
     * @type {string}
     * @memberof MainContextSection
     */
    title: string;
    /**
     * Markdown body of the section (no heading line). Only the {{CLINIC_HOURS}} placeholder is allowed.
     * @type {string}
     * @memberof MainContextSection
     */
    content: string;
    /**
     * Which AI surfaces include this section. Defaults to [patient_chat, staff] when absent.
     * @type {Array<string>}
     * @memberof MainContextSection
     */
    channels?: Array<MainContextSectionChannelsEnum>;
}


/**
 * @export
 */
export const MainContextSectionChannelsEnum = {
    PatientChat: 'patient_chat',
    Staff: 'staff',
    Email: 'email'
} as const;
export type MainContextSectionChannelsEnum = typeof MainContextSectionChannelsEnum[keyof typeof MainContextSectionChannelsEnum];


/**
 * Check if a given object implements the MainContextSection interface.
 */
export function instanceOfMainContextSection(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "content" in value;

    return isInstance;
}

export function MainContextSectionFromJSON(json: any): MainContextSection {
    return MainContextSectionFromJSONTyped(json, false);
}

export function MainContextSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MainContextSection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'content': json['content'],
        'channels': !exists(json, 'channels') ? undefined : json['channels'],
    };
}

export function MainContextSectionToJSON(value?: MainContextSection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'content': value.content,
        'channels': value.channels,
    };
}

